module.exports = __webpack_public_path__ + "img/image-20230124-140940.b0175d44.png";